// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ytJ9B","list":"styles_list__1kAq6"};